export const IGNORED_EXCEPTION_MESSAGES = [
  "member called after shutdown",
  "Uncaught ReferenceError: member called after shutdown",
  "Incompatible load types.",
  "Cannot pick from outside the canvas area.",
  "ResizeObserver loop",
  "ResizeObserver loop completed with undelivered notifications",
  // Sentry errors cause by vite:preloadError
  "dynamically imported module",
  "Importing a module script failed",
  "Failed to load module script",
  "Unable to preload CSS",
  // MSAL loginPopup blocked by the browser's popup blocker
  "popup_window_error",
  // MSAL popup abandoned past the bridge timeout — user walked away, not a failure
  "msal.js.errors#timed_out",
  // expo-location rejection when the user has denied location permission
  "Location permission is required to do this operation",
  // expo-location failures (GPS unavailable, timeout, permission)
  "Calling the 'getCurrentPositionAsync' function has failed",
  // expo-image-picker iOS failure reading a photo-library asset (e.g. iCloud-offloaded)
  "Failed to read picked image",
];
